import { render } from "./DefaultAvatar.vue?vue&type=template&id=6a07da9c"
import script from "./DefaultAvatar.vue?vue&type=script&lang=js"
export * from "./DefaultAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__